import React from "react";
import Paper from "@mui/material/Paper";

interface IProps {
    children: React.ReactNode, 
    paperKey: string, 
    uniqueId?: string, 
    style?: any, 
    overridePadding?: number | string
}

/**
 * Wraps dash element in paper border
 */
export function DashPaper(props: IProps) {
    const { children, paperKey, uniqueId, style, overridePadding } = props;
    
    return (
        <Paper elevation={1} key={paperKey} className={"dash-flat-paper flat-paper"} style={style}>
            <div style={{ padding: overridePadding || 24 }} id={uniqueId || null} className={"paper-content"}>
                {children}
            </div>
        </Paper>
    );
 }

 //function dashPaper(element: JSX.Element, key: string, uniqueId?: string, style?: any, overridePadding?: number | string) {